// Keep the unpublished restoration sample outside the purchase flow.
document.addEventListener('submit', event => {
  if (event.target.closest('product-form-component[data-product-id="15412613480816"]')) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);
document.addEventListener('click', event => {
  if (event.target.closest('product-form-component[data-product-id="15412613480816"]') && event.target.closest('[data-lp-checkout], [ref="addToCartButton"]')) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);
(() => {
  const finder = document.querySelector('#lp-team-finder');
  if (finder && finder.querySelector('[data-lp-team-search]')) {
    let sport = 'all';
    const search = finder.querySelector('[data-lp-team-search]');
    const filter = () => {
      const term = search.value.trim().toLocaleLowerCase();
      let total = 0;
      finder.querySelectorAll('[data-lp-group]').forEach(group => {
        let count = 0;
        group.querySelectorAll('[data-lp-team]').forEach(team => {
          const match = (sport === 'all' || sport === group.dataset.lpGroup) && team.dataset.lpTeam.toLocaleLowerCase().includes(term);
          team.hidden = !match;
          if (match) count++;
        });
        group.hidden = !count;
        total += count;
      });
      finder.querySelector('[data-lp-no-teams]').hidden = total > 0;
    };
    search.addEventListener('input',filter);
    finder.querySelectorAll('[data-lp-sport]').forEach(button => button.addEventListener('click',() => {
      sport = button.dataset.lpSport;
      finder.querySelectorAll('[data-lp-sport]').forEach(item => item.setAttribute('aria-pressed',String(item === button)));
      filter();
    }));
  }
  const limitedPicker = form => {
    const teamPicker = form.querySelector('[data-lp-gridiron-team]');
    if (teamPicker) return teamPicker;
    const component = form.closest('product-form-component');
    if (!component?.dataset.productId) return null;
    const picker = component.closest('.shopify-section, dialog')
      ?.querySelector('variant-picker[data-product-id="' + component.dataset.productId + '"]');
    return picker?.querySelector('[data-lp-gridiron]') ? picker : null;
  };
  const limitedSelector = form => limitedPicker(form)?.lpGridiron;
  const selectedVariant = form => {
    if (limitedPicker(form)) return limitedSelector(form)?.variant || null;
    const picker = form.hasAttribute('data-lp-team-form') ? null : form.closest('.shopify-section')?.querySelector('variant-picker');
    const options = picker ? Array.from(picker.querySelectorAll('fieldset[data-lp-option]')).map(group => group.querySelector('input:checked')?.getAttribute('aria-label')) : [];
    const data = form.querySelector('[data-lp-checkout-variants]');
    if (!data) return null;
    const variants = JSON.parse(data.textContent);
    return options.length ? variants.find(variant => variant.options.every((option,index) => option === options[index])) : variants.find(variant => String(variant.id) === new FormData(form).get('id'));
  };
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-lp-team-variant]');
    if (!input) return;
    const article = input.closest('[data-lp-team-product]');
    if (article) article.dataset.lpFinish = input.dataset.material.toLowerCase().includes('canvas') ? 'canvas' : 'paper';
    if (input.checked && !input.disabled && (article?.hasAttribute('data-lp-limited-product') || input.closest('[data-lp-twelve="team"]'))) {
      const price = article.querySelector('[data-lp-team-price]');
      if (price) price.textContent = input.dataset.priceText;
    }
  });
  // Handle the form before Shopify's document listener observes the submit.
  // The Ajax cart response supplies the single product_added_to_cart event.
  const handleTeamSubmit = async event => {
    const form = event.currentTarget;
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-lp-checkout-error]');
    const selected = selectedVariant(form);
    if (!selected?.available || submit.disabled) return;
    const limited = limitedSelector(form);
    if (limited && !(await limited.beginPurchase())) return;
    const body = new FormData(form);
    if (limited) {
      body.set('id', limited.selectedId);
      body.set('quantity', '1');
    }
    submit.disabled = true;
    error.hidden = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {method:'POST', body, headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || error.dataset.errorMessage);
      window.location.assign(root + 'cart');
    } catch (failure) {
      error.textContent = failure.message || error.dataset.errorMessage;
      error.hidden = false;
      submit.disabled = false;
      limited?.purchaseError(failure.message);
    } finally {
      limited?.endPurchase();
    }
  };
  const boundTeamForms = new WeakSet();
  const initializeTeamForms = () => {
    document.querySelectorAll('form[data-lp-team-form]').forEach(form => {
      if (boundTeamForms.has(form)) return;
      boundTeamForms.add(form);
      form.addEventListener('submit', handleTeamSubmit);
    });
  };
  initializeTeamForms();
  document.addEventListener('shopify:section:load', initializeTeamForms);
  let checkoutPending = false;
  let scheduled = false;
  const updateSticky = () => {
    scheduled = false;
    let visible = false;
    document.querySelectorAll('[data-lp-sticky]').forEach(bar => {
      const form = bar.closest('form');
      const main = form?.querySelector('.lp-direct-checkout > [data-lp-checkout]');
      if (!main) return;
      const variant = selectedVariant(form);
      const rect = main.getBoundingClientRect();
      const show = rect.bottom <= 0 || rect.top >= window.innerHeight;
      bar.hidden = !show;
      visible ||= show;
      const price = bar.querySelector('[data-lp-sticky-price]');
      if (price && price.textContent !== (variant?.priceText || '')) price.textContent = variant?.priceText || '';
      const section = form.closest('.shopify-section');
      const type = (variant?.options[variant.options.length - 1] || '').toLowerCase();
      const finish = (type === 'framed canvas' || type.includes('black frame')) ? 'black' : type.includes('canvas') ? 'canvas' : 'paper';
      if (section) section.dataset.lpFinish = finish;
      bar.querySelector('button').disabled = checkoutPending || !variant?.available || !!form.querySelector('[ref="addToCartButton"]')?.disabled;
    });
    document.body.classList.toggle('lp-sticky-visible',visible);
  };
  const scheduleSticky = () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(updateSticky); }
  };
  window.addEventListener('scroll',scheduleSticky,{passive:true});
  window.addEventListener('resize',scheduleSticky);
  document.addEventListener('change',scheduleSticky);
  new MutationObserver(scheduleSticky).observe(document.querySelector('main') || document.body,{childList:true,subtree:true});
  scheduleSticky();
  document.addEventListener('click', event => {
    const chatLink = event.target.closest('[data-lp-open-chat]');
    if (chatLink) {
      const chatRoot = document.querySelector('shopify-chat')?.shadowRoot;
      const chatButton = chatRoot?.querySelector('button[part="activator"]') || chatRoot?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('button[part="activator"]');
      if (chatButton && chatButton.getAttribute('aria-expanded') !== 'true') {
        document.querySelector('shopify-chat').setAttribute('open', '');
        chatRoot?.querySelector('shopify-agent-runtime')?.setAttribute('open', '');
      }
      return;
    }
  }, true);
  document.addEventListener('click', async event => {
    const notice = event.target.closest('[data-lp-checkout-notice]');
    if (notice) {
      notice.parentElement.querySelector('[data-lp-checkout]')?.focus();
      return;
    }
    const button = event.target.closest('[data-lp-checkout]');
    if (!button || button.disabled || checkoutPending) return;
    const form = button.closest('form');
    const nativeButton = form?.querySelector('[ref="addToCartButton"]');
    if (!form || !nativeButton || nativeButton.disabled) return;
    const error = form.querySelector('[data-lp-checkout-error]');
    const limited = limitedSelector(form);
    if (limitedPicker(form) && !limited) {
      error.textContent = 'The edition selector is loading. Please try again.';
      error.hidden = false;
      return;
    }
    if (limited && !(await limited.beginPurchase())) return;
    const body = new FormData(form);
    if (limited) {
      body.set('id', limited.selectedId);
      body.set('quantity', '1');
    }
    body.delete('sections');
    const selected = selectedVariant(form);
    if (!selected || !selected.available) {
      error.textContent = error.dataset.errorMessage;
      error.hidden = false;
      limited?.endPurchase();
      return;
    }
    body.set('id',String(selected.id));
    checkoutPending = true;
    scheduleSticky();
    button.disabled = true;
    button.setAttribute('aria-busy','true');
    error.hidden = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js',{method:'POST',body,headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || error.dataset.errorMessage);
      window.location.assign(root + 'checkout');
    } catch (failure) {
      error.textContent = failure.message || error.dataset.errorMessage;
      error.hidden = false;
      limited?.purchaseError(failure.message);
      checkoutPending = false;
      scheduleSticky();
      button.disabled = false;
      button.removeAttribute('aria-busy');
    } finally {
      limited?.endPurchase();
    }
  });
})();




(() => {
const syncPrice = (group) => {
const input = group.querySelector('input:checked') || [...group.querySelectorAll('input[data-lp-team-variant]')].find(input => !input.closest('label').hidden);
const price = group.querySelector('[data-lp-limited-price]');
if (price && input) price.textContent = input.dataset.priceText;
};
const applyMaterial = (group, material) => {
const form = group.closest('form');
group.querySelectorAll('[data-lp-material]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.lpMaterial === material)));
group.querySelectorAll('[data-lp-edition-material]').forEach(label => label.hidden = label.dataset.lpEditionMaterial !== material);
let selected = group.querySelector('input:checked');
if (!selected || selected.closest('label').hidden || selected.disabled) {
if (selected) selected.checked = false;
selected = [...group.querySelectorAll('input[data-lp-team-variant]')].find(input => !input.disabled && !input.closest('label').hidden);
if (selected) selected.checked = true;
}
form.querySelectorAll('[ref="addToCartButton"],[data-lp-checkout]').forEach(button => button.disabled = !selected);
syncPrice(group);
if (selected) selected.dispatchEvent(new Event('change',{bubbles:true}));
};
const initialize = () => document.querySelectorAll('[data-lp-limited]').forEach(group => {
if (group.dataset.initialized) return;
group.dataset.initialized = 'true';
const selected = group.querySelector('input:checked');
applyMaterial(group,selected?.dataset.material || 'Paper');
});
document.addEventListener('click',event => {
const button = event.target.closest('[data-lp-material]');
if (button) applyMaterial(button.closest('[data-lp-limited]'),button.dataset.lpMaterial);
});
document.addEventListener('change', event => {
const group = event.target.closest('[data-lp-limited]');
if (group) syncPrice(group);
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize); else initialize();
document.addEventListener('shopify:section:load',initialize);
})();


(() => {
  const syncOptions = (form, changedIndex = null) => {
    const groups = [...form.querySelectorAll('[data-lp-team-option-group]')];
    if (!groups.length) return;
    const variants = JSON.parse(form.querySelector('[data-lp-checkout-variants]').textContent);
    const choices = groups.map(group => group.querySelector('input:checked')?.value);
    let selected = variants.find(variant => variant.options.every((value, index) => value === choices[index]));
    if (!selected) {
      selected = variants.find(variant => variant.available && (changedIndex === null || variant.options[changedIndex] === choices[changedIndex]));
      selected ||= variants.find(variant => changedIndex === null || variant.options[changedIndex] === choices[changedIndex]);
    }
    if (!selected) return;
    groups.forEach((group,index) => {
      group.querySelectorAll('input').forEach(input => {
        input.checked = input.value === selected.options[index];
        const available = variants.some(variant => variant.available && variant.options[index] === input.value && (index === 0 || variant.options[0] === selected.options[0]));
        const restored = !!form.closest('[data-lp-standard-options]');
        const exists = variants.some(variant => variant.options[index] === input.value && (index === 0 || variant.options[0] === selected.options[0]));
        input.disabled = restored ? !exists : !available;
        input.closest('label').classList.toggle('lp-team-variant-sold', !available);
      });
    });
    form.querySelector('[data-lp-selected-variant]').value = selected.id;
    form.querySelector('[data-lp-team-price]').textContent = selected.priceText;
    form.querySelectorAll('[ref="addToCartButton"], [data-lp-checkout]').forEach(button => button.disabled = !selected.available);
    const type = selected.options[selected.options.length - 1].toLowerCase();
    form.closest('[data-lp-team-product]').dataset.lpFinish = (type === 'framed canvas' || type.includes('black frame')) ? 'black' : type.includes('canvas') ? 'canvas' : 'paper';
  };
  const initialize = () => document.querySelectorAll('form[data-lp-team-form]').forEach(form => syncOptions(form));
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-lp-team-option]');
    if (!input) return;
    syncOptions(input.closest('form'), Number(input.closest('[data-lp-team-option-group]').dataset.lpTeamOptionGroup));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();



